import api from './axios';

// ── Public (no login required) ────────────────────────────────────────────

export const getPublicPosts = (page = 0, size = 12, search = '') =>
  api.get('/gallery/posts', { params: { page, size, search: search || undefined } });

export const getPublicPost = (id) => api.get(`/gallery/posts/${id}`);

export const getTags = () => api.get('/gallery/tags');

// ── Admin (ADMIN/CURATOR only) ────────────────────────────────────────────

export const listAdminPosts = (page = 0, size = 20, search = '') =>
  api.get('/admin/gallery/posts', { params: { page, size, search: search || undefined } });

export const createPost = (caption, tags, imageFiles) => {
  const formData = new FormData();
  if (caption) formData.append('caption', caption);
  (tags || []).forEach((tag) => formData.append('tags', tag));
  imageFiles.forEach((file) => formData.append('images', file));
  return api.post('/admin/gallery/posts', formData);
};

export const updatePost = (id, body) => api.put(`/admin/gallery/posts/${id}`, body);

export const addPostImages = (id, imageFiles) => {
  const formData = new FormData();
  imageFiles.forEach((file) => formData.append('images', file));
  return api.post(`/admin/gallery/posts/${id}/images`, formData);
};

export const removePostImage = (postId, imageId) =>
  api.delete(`/admin/gallery/posts/${postId}/images/${imageId}`);

export const deletePost = (id) => api.delete(`/admin/gallery/posts/${id}`);
